import {Component, OnInit} from '@angular/core';
import {Angular2Csv} from 'angular2-csv/Angular2-csv';
import * as moment from 'moment';
import {OwnerService} from '../services/owner.service';
import {OwnersAdvanceSearch} from '../models/data-model';
import {ExportAvailability} from '../../../config';
import {Router} from '@angular/router';

@Component({
    selector: 'app-owner-export',
    templateUrl: '../views/owner-export.component.html',
    styleUrls: ['../css/owner-export.component.css']
})
export class OwnerExportComponent implements OnInit {

    public userId: number;
    public countryList: any;
    public dealerList: any;
    public ownershipCycle: any;
    public salesType: any;
    public showsubmission: boolean = true;
    public showsubmissionrange: boolean = false;
    public advanceOwnerSearchfields = new OwnersAdvanceSearch("", null, null, null, null, "", null, null, null, 0, 10, true, "", "","",[],false);
    public current: any = [];
    public remaining: any = [];
    public index: number;
    public addToRemaining: any = [];
    public addTocurrent: any = [];
    public limit: number = 10;
    public offset: number = 0;
    public showBack: boolean = false;
    public showNext: boolean = true;
    public noData: boolean = false;
    public data: any = [];
    public prepareData: any = [];
    public savePreference: any;
    public prepareCurrentToSave: any = [];
    public finalExportData: any = [];
    public temp: any;
    public headerData: any = [];
    public rowdata: any = [];
    public refine: any = [];
    public columns: any = [];
    public enablePagination: boolean = true;
    public exportData: any;
    public showRequiredMsg: boolean = false;
    public moveToTab2: boolean = false;
    public EXPORT = ExportAvailability.export;

    //dropdown values
    public salesTypeSelected: any = [];
    public countrySelected: any = [];
    public ownershipCycleSelected: any = [];
    public dealerListSelected: any = [];
    
    //Boolean
    public isSalesTypeAll: boolean=false;
    public isCountryAll: boolean=false;
    public isOwnershipCycleAll: boolean=false;
    public isDealerListAll: boolean=false;
    
    //Settings for dropdowns
    public countrySettings = {
        singleSelection: false,
        idField: 'id',
        textField: 'namecode',
        selectAllText: 'Select All',
        unSelectAllText: 'Unselect All',
        itemsShowLimit: 1,
        allowSearchFilter: false
    };
    public salesTypeSettings = {
        singleSelection: false,
        idField: 'id',
        textField: 'desccode',
        selectAllText: 'Select All',
        unSelectAllText: 'Unselect All',
        itemsShowLimit: 1,
        allowSearchFilter: false
    };
    public ownershipCycleSettings = {
        singleSelection: false,
        idField: 'id',
        textField: 'desccode',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 1,
        allowSearchFilter: false
    };
    public dealerListSettings = {
        singleSelection: false,
        idField: 'id',
        textField: 'desccode',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 1,
        allowSearchFilter: false
    };


    constructor(public _ownerService: OwnerService,private _router:Router) {}

    ngOnInit() {
        if (!this.EXPORT) {
            this._router.navigate(['/owners']);
        }
        //this.userId = Number(localStorage.getItem('userId'));
        this.userId = Number(sessionStorage.getItem('userId'));
        this.getCountryList();
        this.getOwnershipCycle();
        this.getDealerList();
        this.getSalesType();
        this.getPreference();
      const tab2 = document.getElementById('tab12');
      const tab3 = document.getElementById('tab13');
      tab2.classList.add("disabled");
        tab3.classList.add("disabled");
    }

    /**
    * @author Nagendra
    * @description Get country List
    */
    getCountryList() {
        this._ownerService.getCountryListWithNamecode(result => {
            this.countryList = result
        })
    }

    /**
    * @author Nagendra
    * @description Get Dealer List
    */
    getDealerList() {
        this._ownerService.getDealerListWithDesccode(this.userId, result => {
            this.dealerList = result;
        })
    }

    /**
    * @author Nagendra
    * @description Get Sales Type
    */
    getSalesType() {
        this._ownerService.getSalesTypeWithDesccode(result => {
            this.salesType = result;
        })
    }

    /**
    * @author Nagendra
    * @description Get Ownership cycle
    */
    getOwnershipCycle() {
        this._ownerService.getOwnershipCycleWithDesccode(result => {
            this.ownershipCycle = result;
        })
    }

    fromCurrent(value, index) {
      const assign = document.getElementById("current_" + index);
      assign.classList.toggle("active");
        if (this.addToRemaining.indexOf(value) !== -1) {
            this.index = this.addToRemaining.indexOf(value);
            this.addToRemaining.splice(this.index, 1)
        }
        else {this.addToRemaining.push(value);}
    }

    fromRemaining(value, index) {
      const assign = document.getElementById("remaining_" + index);
      assign.classList.toggle("active");
        if (this.addTocurrent.indexOf(value) !== -1) {
            this.index = this.addTocurrent.indexOf(value);
            this.addTocurrent.splice(this.index, 1)
        }
        else {this.addTocurrent.push(value);}
    }

    filterCurrent() {
        this.addToRemaining.forEach(Obj => {
            this.remaining.push(Obj)
        });
        this.addToRemaining.forEach(each => {
            this.index = this.current.indexOf(each);
            this.current.splice(this.index, 1)
        });
        this.addToRemaining = [];
    }

    filterRemaining() {
        this.addTocurrent.forEach(Obj => {
            this.current.push(Obj)
        });
        this.addTocurrent.forEach(each => {
            this.index = this.remaining.indexOf(each);
            this.remaining.splice(this.index, 1)
        });
        this.addTocurrent = [];
    }

    GoBack() {
        this.offset -= 10;
        if (this.offset == 0) {
            this.showBack = false;
            this.noData = false;
        }
        if (this.offset != 0) {
            this.showNext = true;
        }
        this.advanceSearch();

      const tab2 = document.getElementById('tab12');
      const tab3 = document.getElementById('tab13');
      tab2.classList.add("disabled");
        tab2.classList.remove("active");
        tab3.classList.add("active");
        tab3.classList.remove("disabled");
    }
    /**
     * @author Nagendra
     * @description Get Next Page
     */
    nextPage() {
        this.offset += 10;
        if (this.offset != 0) {
            this.showBack = true;
        }
        this.advanceSearch();
      const tab2 = document.getElementById('tab12');
      const tab3 = document.getElementById('tab13');
      tab2.classList.add("disabled");
        tab2.classList.remove("active");
        tab3.classList.add("active");
        tab3.classList.remove("disabled");
    }


    advanceSearch() {
        if (this.advanceOwnerSearchfields.lastName.trim() != "" ||
            Object.keys(this.countrySelected).length > 0 ||
            Object.keys(this.salesTypeSelected).length > 0 ||
            Object.keys(this.ownershipCycleSelected).length > 0 ||
            Object.keys(this.dealerListSelected).length > 0 ||
            this.advanceOwnerSearchfields.vin.trim() != "" ||
            this.advanceOwnerSearchfields.fromPurchaseDate != null ||
            this.advanceOwnerSearchfields.toPruchaseDate != null) {
            
            this.advanceOwnerSearchfields.countryIds = [];
            this.advanceOwnerSearchfields.salesTypeIds= [];
            this.advanceOwnerSearchfields.ownershipStatusList= [];
            this.advanceOwnerSearchfields.dealerIds= [];
            /**
             * @author Nagendra
             * @description dropdowns value are checked,if select all/unselect all used then boolean value for that will be true and it sends empty array
             */

            if (Object.keys(this.salesTypeSelected).length > 0 && this.salesTypeSelected != undefined && this.isSalesTypeAll != true) {
                Object.keys(this.salesTypeSelected).map(key => this.advanceOwnerSearchfields.salesTypeIds.push(this.salesTypeSelected[key]['id']));
            }
            if (Object.keys(this.countrySelected).length > 0 && this.countrySelected != undefined && this.isCountryAll != true) {
                Object.keys(this.countrySelected).map(key => this.advanceOwnerSearchfields.countryIds.push(this.countrySelected[key]['id']));
            }
            if (Object.keys(this.ownershipCycleSelected).length > 0 && this.ownershipCycleSelected != undefined && this.isOwnershipCycleAll != true ) {
                Object.keys(this.ownershipCycleSelected).map(key => this.advanceOwnerSearchfields.ownershipStatusList.push(this.ownershipCycleSelected[key]['id']));
            }
            if (Object.keys(this.dealerListSelected).length > 0 && this.dealerListSelected != undefined && this.isDealerListAll != true) {
                Object.keys(this.dealerListSelected).map(key => this.advanceOwnerSearchfields.dealerIds.push(this.dealerListSelected[key]['id']));
            }
            
            
            //For active class & disabled class
          const tab11 = document.getElementById("tab11");
          tab11.classList.remove("active");
            tab11.classList.add("disabled");
          const tab12 = document.getElementById("tab12");
          tab12.classList.add("active");
            tab12.classList.remove("disabled");
          const tab13 = document.getElementById("tab13");
          tab13.classList.remove("active");
            tab13.classList.add("disabled");

            this.data = [];
            this.advanceOwnerSearchfields.userId = this.userId;
            this.advanceOwnerSearchfields.isPagination = this.enablePagination;
            this.advanceOwnerSearchfields.offset = this.offset;
            this.showRequiredMsg = false;
            this.moveToTab2 = true;
            this._ownerService.getSearchOwnerList(this.advanceOwnerSearchfields, (result) => {
                this.data = result.beans;
                if (this.data == '') {
                    this.showNext = false;
                    this.noData = true;
                }
                if (this.data.length < '10' && result != '') {
                    this.showNext = false;
                    this.noData = false;
                }
                if (this.data.length == '10') {
                    this.showNext = true;
                    this.noData = false;
                }
            })
        } else {
            this.moveToTab2 = false;
            this.showRequiredMsg = true;
        }

    }

    showdaterange(val) {
        if (this.showsubmission) {
            this.showsubmission = false;
            this.showsubmissionrange = val;
        } else {
            this.showsubmission = val;
            this.showsubmissionrange = false;
        }

    }


    exportList() {
        this.enablePagination = false;
        this.advanceOwnerSearchfields.isPagination = this.enablePagination;
      const today: string = moment().format('D MMM YYYY HH:mm:ss');
      const options = {
        showLabels: true,
        headers: this.headerData
      };
      this._ownerService.getSearchOwnerList(this.advanceOwnerSearchfields, (result) => {
            this.exportData = result;
            this.exportData.forEach(eachObj => {
                this.temp = {};
                this.prepareCurrentToSave.forEach(prefprop => {
                    if (eachObj[prefprop.property] != "" || eachObj[prefprop.property] != null) {
                        if (prefprop.property == "purchaseDate") {
                            eachObj[prefprop.property] = moment(eachObj[prefprop.property]).format("MM/DD/YYYY ");
                        }
                        this.temp[prefprop.label] = eachObj[prefprop.property];
                    } else {

                        this.temp[prefprop.label] = null;
                    }

                });
                this.finalExportData.push(this.temp);
            });
            new Angular2Csv(this.finalExportData, 'My_Owner_Report' + today, options);
        });
        this.enablePagination = true;
    }

    getPreference() {
        this.current = [];
        this.remaining = [];
        this._ownerService.getOwnerPreference(this.userId, (result) => {
            if (result.length != 0) {
                result.forEach(each => {
                    this.current.push(each.setting.label);
                });
                this._ownerService.getviewSettings(allPreference => {
                    allPreference.forEach(res => {
                        this.refine.push(res.label);
                    });
                  const thisObj = this;
                  this.refine.filter(function (item) {
                        if (thisObj.current.indexOf(item) === -1) {thisObj.remaining.push(item)}
                    });
                });
            } else {this.getDefaultPreferences();}
        });

    }

    /**
 * @author Nagendra
 * @description Get default user preference
 * @returns All settings preference
 */
    getDefaultPreferences() {
        this.current = [];
        this.remaining = [];
        this._ownerService.getviewSettings(allPreference => {
            allPreference.forEach(Obj => {
                if (Obj.isDefult == true) {this.current.push(Obj.label)}
                if (Obj.isDefult == false) {this.remaining.push(Obj.label)}
            });
        });
    }

    setUserPreference() {
        //For active class & disabled class
      const tab11 = document.getElementById("tab11");
      tab11.classList.remove("active");
        tab11.classList.add("disabled");
      const tab12 = document.getElementById("tab12");
      tab12.classList.remove("active");
        tab12.classList.add("disabled");
      const tab13 = document.getElementById("tab13");
      tab13.classList.add("active");
        tab13.classList.remove("disabled");

        this.savePreference = {};
        this.prepareCurrentToSave = [];
        this.finalExportData = [];
        this.rowdata = [];
        this.headerData = [];
        this._ownerService.getviewSettings(allPreference => {
            
            allPreference.forEach(field => {
                this.current.forEach((obj, index) => {
                    if (field.label == obj) {
                        this.headerData.splice(index, 0, obj);
                      const object = field.property;
                      const refined = object.substring(object.indexOf(".") + 1);
                      field.property = refined.trim();
                        this.prepareCurrentToSave.splice(index, 0, {
                            "label": obj,
                            "property": field.property,
                        })
                    }
                })
            });
                
        });
        this.rowdata = this.prepareCurrentToSave;
    }

    reset() {
        this.current = [];
        this.remaining = [];
        this.addToRemaining = [];
        this.addTocurrent = [];
        this.refine = [];
        this.getPreference();
    }

    returnToSearch() {
      const tab11 = document.getElementById("tab11");
      tab11.classList.add("active");
        tab11.classList.remove("disabled");
      const tab12 = document.getElementById("tab12");
      tab12.classList.remove("active");
        tab12.classList.add("disabled");
      const tab13 = document.getElementById("tab13");
      tab13.classList.remove("active");
        tab13.classList.add("disabled");
    }

    returnToFieldSettings() {
      const tab11 = document.getElementById("tab11");
      tab11.classList.remove("active");
        tab11.classList.add("disabled");
      const tab12 = document.getElementById("tab12");
      tab12.classList.add("active");
        tab12.classList.remove("disabled");
      const tab13 = document.getElementById("tab13");
      tab13.classList.remove("active");
        tab13.classList.add("disabled");
    }

    hideSelectMsg() {
        this.showRequiredMsg = false;
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/owners/components/owner-export.component.ts